import { Component } from 'react';
import PropTypes from 'prop-types';
import { IoChevronBackOutline, IoChevronForwardOutline, IoText } from "react-icons/io5";

class CardForm extends Component {

  state = {
    index: 0
  };

  constructor(props) {
    super(props);
    this.handleChangeHOC = this.handleChangeHOC.bind(this);
    this.handleValueHOC = this.handleValueHOC.bind(this);
    this.handleFontSizeHOC = this.handleFontSizeHOC.bind(this);
  }

  handleChangeHOC(index) {
    return () => {
      this.props.onIndexChanged(index);
    }
  }

  handleValueHOC(id) {
    return (e) => {
      this.props.onValueChanged(id, e.target.value);
    }
  }

  handleFontSizeHOC(id, value) {
    return () => {
      this.props.onFontSizeChanged(id, value);
    };
  }

  render() {
    const currentObject = this.props.layout.objects[this.props.selectedIndex];
    const value = (currentObject.id in this.props.values) ? this.props.values[currentObject.id] : '';
    const fontSize = (currentObject.id in this.props.fontSizes) ? this.props.fontSizes[currentObject.id] : currentObject.fontSize;

    return (
      <div className="t-form-pane">
        <div className="arrow prev">
          <button className="btn btn-light" onClick={this.handleChangeHOC(this.props.selectedIndex - 1)} disabled={this.props.selectedIndex === 0}>
            <IoChevronBackOutline />
          </button>
        </div>
        <div className="t-form-main">
          <div className="t-form-main-body">
            <div className="text-center mb-2">
              <span className="badge bg-dark">{currentObject.label}</span>
            </div>

            <div className="form-group">
              <input type="text" className="form-control" value={value} placeholder={'例:' + currentObject.sample} onChange={this.handleValueHOC(currentObject.id)} />
              <button className="btn btn-light btn-text-small" onClick={this.handleFontSizeHOC(currentObject.id, fontSize - 1)}>
                <IoText />
              </button>
              <button className="btn btn-light btn-text-large" onClick={this.handleFontSizeHOC(currentObject.id, fontSize + 1)}>
                <IoText />
              </button>
            </div>
          </div>
          <div className="t-form-dots">
            {this.props.layout.objects.map((object, i) => {
              return (
                <button key={i} className={this.props.selectedIndex === i ? "btn btn-primary" : "btn btn-light"} />
              );
            })}
          </div>
        </div>
        <div className="arrow next">
          <button className="btn btn-light" onClick={this.handleChangeHOC(this.props.selectedIndex + 1)} disabled={this.props.selectedIndex === (this.props.layout.objects.length - 1)}>
            <IoChevronForwardOutline />
          </button>
        </div>
      </div>
    );
  }
}

CardForm.propTypes = {
  layout: PropTypes.any,
  onIndexChanged: PropTypes.func,
  selectedIndex: PropTypes.number,
  onValueChanged: PropTypes.func,
  onFontSizeChanged: PropTypes.func,
  values: PropTypes.object,
  fontSizes: PropTypes.object
}

CardForm.defaultProps = {
  selectedIndex: 0,
  onIndexChanged: () => { console.warn('Please implement CardForm#onIndexChanged'); },
  onValueChanged: () => { console.warn('Please implement CardForm#onValueChanged'); },
  onFontSizeChanged: () => { console.warn('Please implement CardForm#onFontSizeChanged'); }
};

export default CardForm;